import { GD } from "src/GD";
import { dehydrate, hydrate } from "src/view/fraud/fraud_rule_form";
import { S_FRAUD_GROUPS_POPUP } from "src/view/fraud/FraudGroupsPopup";
import { TFraudGroup, TFraudRule } from "src/view/fraud/types";

export class FraudService {
	constructor() {
		GD.REQ_FRAUD_GROUPS_GET.listener = async () => await this.getGroups();
		GD.REQ_FRAUD_GROUP_SET.listener = async req => await this.setGroup(req);
		GD.REQ_FRAUD_GROUP_DELETE.listener = async req => await this.deleteGroup(req.groupID);

		GD.REQ_FRAUD_RULES_GET.listener = async () => await this.getRules();
		GD.REQ_FRAUD_RULE_GET.listener = async req => await this.getRule(req.ruleID);
		GD.REQ_FRAUD_RULE_SET.listener = async req => await this.setRule(req);
		GD.REQ_FRAUD_RULE_DELETE.listener = async req => await this.deleteRule(req.ruleID);
	}

	// GROUPS
	async getGroups(): Promise<TFraudGroup[]> {
		const res = await GD.REQ_API.request({
			method: "fraud/groups/list",
			httpMethod: "GET",
		});
		if (res.error) {
			// TODO: Handle error, somehow notify user
			return [];
		}
		return res.data;
	}

	async getGroup(groupID: number) {
		const res = await GD.REQ_API.request({
			method: "fraud/group/get",
			httpMethod: "POST",
			data: {
				id: groupID,
			},
		});
		if (res.error) {
			// TODO: Handle error, somehow notify user
			return null;
		}
		return res.data;
	}

	async setGroup(groupData: { groupID: number; name: string }) {
		const res = await GD.REQ_API.request({
			method: "fraud/group/set",
			httpMethod: "POST",
			data: {
				id: groupData.groupID,
				name: groupData.name,
			},
		});
		if (res.error) {
			// TODO: Handle error, somehow notify user
			return false;
		}
		S_FRAUD_GROUPS_POPUP.invoke({});
		return res.data;
	}

	async deleteGroup(groupID: number) {
		const res = await GD.REQ_API.request({
			method: "fraud/group/delete",
			httpMethod: "DELETE",
			data: {
				id: groupID,
			},
		});
		if (res.error) {
			// TODO: Handle error, somehow notify user
			return false;
		}
		S_FRAUD_GROUPS_POPUP.invoke({});
		return res.data;
	}

	// RULES
	async getRules(): Promise<TFraudRule[]> {
		const res = await GD.REQ_API.request({
			method: "fraud/rules/list",
			httpMethod: "GET",
		});
		if (res.error) {
			// TODO: Handle error, somehow notify user
			return [];
		}
		return res.data;
	}

	async getRule(ruleID: number) {
		const res = await GD.REQ_API.request({
			method: "fraud/rule/get",
			httpMethod: "POST",
			data: {
				id: ruleID,
			},
		});
		if (res.error) {
			// TODO: Handle error, somehow notify user
			return null;
		}
		return {
			...res.data,
			data: hydrate(res.data.data),
		};
	}

	async setRule(ruleData: { ruleID: number; data: TFraudRule }) {
		const res = await GD.REQ_API.request({
			method: "fraud/rule/set",
			httpMethod: "POST",
			data: {
				id: ruleData.ruleID,
				data: dehydrate(ruleData.data),
			},
		});
		if (res.error) {
			// TODO: Handle error, somehow notify user
			return false;
		}
		S_FRAUD_GROUPS_POPUP.invoke({});
		return res.data;
	}

	async deleteRule(ruleID: number) {
		const res = await GD.REQ_API.request({
			method: "fraud/rule/delete",
			httpMethod: "DELETE",
			data: {
				id: ruleID,
			},
		});
		if (res.error) {
			// TODO: Handle error, somehow notify user
			return false;
		}
		S_FRAUD_GROUPS_POPUP.invoke({});
		return res.data;
	}
}
